<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">The Warriors of Raw: The Battle for Souls</h1>
<ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li>
<li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-4"><a href="#/text/ch004#acknowledgment">Acknowledgment</a></li>
<li id="toc-li-5"><a href="#/text/ch005#prologue">Prologue</a></li>
<li id="toc-li-6"><a href="#/text/ch006#chapter-1-sad-events">Chapter 1 Sad Events</a></li>
<li id="toc-li-7"><a href="#/text/ch007#chapter-2-wicked-possessions">Chapter 2 Wicked Possessions</a></li>
<li id="toc-li-8"><a href="#/text/ch008#chapter-3-first-fight">Chapter 3 First Fight</a></li>
<li id="toc-li-9"><span href="#/text/ch009#chapter-4-visions-and-dreamy-memories" title="Link target outside of Sample">Chapter 4 Visions and Dreamy Memories</span></li>
<li id="toc-li-10"><span href="#/text/ch010#chapter-5-the-spies-of-good-and-bad" title="Link target outside of Sample">Chapter 5 The Spies of Good and Bad</span></li>
<li id="toc-li-11"><span href="#/text/ch011#chapter-6-journey-to-the-future" title="Link target outside of Sample">Chapter 6 Journey to the Future</span></li>
<li id="toc-li-12"><span href="#/text/ch012#chapter-7-saving-the-pope" title="Link target outside of Sample">Chapter 7 Saving The Pope</span></li>
<li id="toc-li-13"><span href="#/text/ch013#chapter-8-the-traumatic-events" title="Link target outside of Sample">Chapter 8 The Traumatic Events</span></li>
<li id="toc-li-14"><span href="#/text/ch014#chapter-9-the-visitors" title="Link target outside of Sample">Chapter 9 The Visitors</span></li>
<li id="toc-li-15"><span href="#/text/ch015#chapter-10-the-journey-home" title="Link target outside of Sample">Chapter 10 The Journey Home</span></li>
<li id="toc-li-16"><span href="#/text/ch016#chapter-11-heavenly-help" title="Link target outside of Sample">Chapter 11 Heavenly Help</span></li>
<li id="toc-li-17"><span href="#/text/ch017#chapter-12-search-for-the-shaft-of-light" title="Link target outside of Sample">Chapter 12 Search for The Shaft of Light</span></li>
<li id="toc-li-18"><span href="#/text/ch018#chapter-13-preparations-for-war" title="Link target outside of Sample">Chapter 13 Preparations for War</span></li>
<li id="toc-li-19"><span href="#/text/ch019#chapter-14-the-battle-for-souls" title="Link target outside of Sample">Chapter 14 The Battle for Souls</span></li>
<li id="toc-li-20"><span href="#/text/ch020#chapter-15-the-final-clash" title="Link target outside of Sample">Chapter 15 The Final Clash</span></li>
<li id="toc-li-21"><span href="#/text/ch021#epilogue" title="Link target outside of Sample">Epilogue</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?4a7be872